import * as yup from 'yup';
import { PaginatedResponseMetaSchema } from '../../schemas/PaginatedResponseMetaSchema';

export const OrgPermissionSchema = yup.object({
  id: yup.number().defined(),
  user_type: yup.string().defined(),
  user_id: yup.string().defined(),
  role_id: yup.string().defined(),
  object_type: yup.string().nullable(),
  object_id: yup.string().nullable(),
  granted_at: yup.date().defined(),
  org_id: yup.number().defined(),
});

export type OrgPermission = yup.InferType<typeof OrgPermissionSchema>;

export const OrgPermissionsResponseSchema = yup.object({
  data: yup.array(OrgPermissionSchema.defined()).defined(),
  meta: PaginatedResponseMetaSchema.defined(),
});

export type OrgPermissionsResponse = yup.InferType<
  typeof OrgPermissionsResponseSchema
>;
